import enquiriesReducer from './enquiries.slice';

export * from './enquiries.slice';
export * from './enquiries.thunk';

export default enquiriesReducer;
